<template>
    <div class="footer-wrapper">
        <div class="footer">


            <div class="footer-row">


                <div class="footer-copyright">
                    &copy; 2020, YLW
                </div>


                <div class="footer-links">
                    <div class="footer-item">
                        <router-link :to="{name: 'TermsOfUse'}" target="_blank"
                                     v-html="$ml.with('VueJS').get('termsOfUse')">
                        </router-link>
                    </div>
                    <div class="footer-item">
                        <router-link :to="{name: 'PrivacyPolicy'}" target="_blank"
                                     v-html="$ml.with('VueJS').get('privacyPolicy')">
                        </router-link>
                    </div>
                </div>

                <div class="developed-by">Разработка приложения - <a href="https://www.itbricksoft.com/index.htm" target="_blank">IT Brick</a></div>


            </div>

        </div>
    </div>
</template>




<script>
    import Logo from "./icons/Logo";

    export default {
        name: 'FooterAuth',
        components: {Logo},
    }
</script>


